module.exports = { "default": require("core-js/library/fn/weak-set"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/weak-set.js
// module id = 329
// module chunks = 0